import React from 'react';
import Classes from 'classnames';
import ReportVacationReport from "../../../../core/model2/report/reports/hr/vacation-report/vaction-report";
import AppLoader_Report from "../../../../item-view/report/app-loader";

type Props = {
    companyUser : any // It's not CompanyUser!!!
    curMenuId   : ID | null
    style?      : any
}

export default class UserSectionMenu extends React.Component<Props> {

    onMenuItemClick = (menuItem: any) => {

        if(menuItem.action){
            menuItem.action();
        }
        else{
            gd.goTo(menuItem.url);
        }

    };

    showCalendar =  () => {
        const appParams = {
            report: new ReportVacationReport({
                id: "vacation-report",
                name: "Vacation report",
                autoGenerate: false,
                settings: {
                    userId: this.props.companyUser.userId,
                }
            })
        }

        gd.appManager.loadAndRunItemView(AppLoader_Report, appParams)

    }

    onProClick = (organizationId: ID) => {
        gd.modals.other.upgradeToPro(organizationId);
    };

    render() {

        const { companyUser, curMenuId } = this.props;

        const baseUrl = companyUser.url + '/';

        // if (gdConfig.devMode) submenu.push({ id: 5, name: "Stats", url: this.companyUser.url+"/stats", selected:(this.appName==='stats') });

        const submenu: any[] = [];

        submenu.push({
            id: 'summary',
            name: "Summary",
            url: baseUrl+"summary",
        });

        submenu.push({
            id: 'tasks',
            name: "Tasks",
            url: baseUrl+"tasks",
        });

        submenu.push({
            id: 'activity',
            name: "Activity",
            url: baseUrl+"activity",
        });

        submenu.push({
            id: 'calendar',
            name: "Calendar",
            // url: baseUrl+"calendar",
            action: this.showCalendar
        });

        submenu.push({
            id: 'info',
            name: "Info",
            url: baseUrl+"info",
        });

        /*if (gd.user.isManager()) {
            /!*submenu.push({
                id: 'manage',
                name: "Manage",
                url: baseUrl+"settings",
            });*!/
            // submenu.push({
            //     id: 'settings',
            //     name: "Settings",
            //     url: baseUrl+"settings",
            // });
        }*/


        return (
            <div className="ui5-hmenu menu-plate">
                {submenu.map((menu)=> {
                    // if values not psecified use defaults
                    if (typeof menu.access === 'undefined') menu.access = true;
                    if (typeof menu.isPro === 'undefined') menu.isPro = false;

                    if (!menu.access) {
                        return false;
                    }

                    if (menu.isPro) {
                        return (
                            <div className='item' key={menu.id} onClick={()=>this.onProClick(menu.organizationId)} style={this.props.style}>
                                {menu.name} <div className="i5-pro"></div>
                            </div>
                        );
                    }

                    const classes = Classes('item', {
                        'selected': (menu.id == curMenuId)
                    });

                    return (
                        <div className={classes} key={menu.id} onClick={()=>this.onMenuItemClick(menu)} style={this.props.style}>
                            <div className="label">{menu.name}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
